(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[755],{

/***/ 4461:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/ultimos",
      function () {
        return __webpack_require__(2220);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ PodcastPagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _pages_ultimas__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3493);


var __N_SSP = true;
function PodcastPagination(param) {
    var homeData = param.homeData, navBarData = param.navBarData, tagsData = param.tagsData, segmentacoes = param.segmentacoes, timelineData = param.timelineData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pages_ultimas__WEBPACK_IMPORTED_MODULE_1__["default"], {
        homeData: homeData,
        timelineData: timelineData,
        navBarData: navBarData,
        tagsData: tagsData,
        manualTitle: "\xdaltimos Podcasts",
        manualRouting: "podcast/ultimos",
        segmentacoes: segmentacoes,
        routeType: "tipo",
        route: "podcast"
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,9127,8802,7590,944,2826,5649,9774,2888,179], function() { return __webpack_exec__(4461); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);